import matchList, { MatchList, Pagination } from '@gin-betting/match-list';

import * as components from './components';
import * as selectors from './selectors';
import * as epics from './epics';
import * as constants from './constants';
import reducer, { paginationReducer } from './reducer';
import messages from './messages';
import middleware from './middleware';

import { getTopMarketComponentsBySport } from './getTopMarkets';

export { MatchList, Pagination };
export default {
    components,
    ...matchList,
    selectors: { ...matchList.selectors, ...selectors },
    constants: { ...matchList.constants, ...constants },
    epics,
    reducer,
    paginationReducer,
    getTopMarketComponentsBySport,
    messages,
    middleware,
};
